import Layout from "../../components/layOutWrapper/layOutWrapper";
import ShowMyTravelAllowanceRequests from "../../components/travelAllowanceRequests/showMyTravelAllowanceRequests";

export default function ShowMyTravelAllowanceRequestsView () {
    return (
        <>
            <Layout children={<ShowMyTravelAllowanceRequests/>} sectionTitle="Mis solicitudes de viático"/>
        </>
    )
}